import React, { useEffect, useState } from "react";
import TotalCountCard from "./total-count-card";
import { useDispatch } from "react-redux";

import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

import { Link, useLocation, useNavigate } from "react-router";
import { Navigate } from "react-router-dom";
import useMediaQuery from "../common/custom-hooks/use-media-query";
const UserTotalCount = ({
  isSlideOpen,
  roleCardData,
  openPermissionDrawer,
  roleLoading,
  setRoleLoading,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const isLaptopScreen = useMediaQuery("(max-width: 1536px)");
  console.log("isLaptopScreen", isLaptopScreen);
  console.log("roleCardData", roleCardData);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 p-[30px] pt-[28px] pb-[16px]">
        Roles & Permissions
      </div>
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ${
          isSlideOpen && isLaptopScreen ? "lg:grid-cols-2" : "lg:grid-cols-4"
        } gap-5 px-[30px] py-4 pt-0`}
      >
        {roleLoading
          ? [1, 2, 3, 4].map((v, i) => (
              <TotalCountCard
                title={"Test"}
                openPermissionDrawer={() => openPermissionDrawer("val.roleId")}
                bgColor="bg-[#EFF1FF]"
                count={0}
                loading={loading}
                isSlideOpen={isSlideOpen}
                key={i}
              />
            ))
          : roleCardData &&
            roleCardData.length &&
            roleCardData.map((val) => (
              <TotalCountCard
                title={val.roleName}
                openPermissionDrawer={() => openPermissionDrawer(val.roleId)}
                bgColor="bg-[#EFF1FF]"
                count={val.userCount}
                loading={roleLoading}
                isSlideOpen={isSlideOpen}
                key={val.roleId}
              />
            ))}
      </div>
    </>
  );
};

export default UserTotalCount;
